import { Link } from 'react-router';
import type { ListedDue } from '@tahi/core';
import { payDue, undoPayment } from '../../../data/commands/payments';
import { useCommandEnv } from '../../../data/hooks';
import { Button, showToast } from '../../../ui';
import { ACCENT_LINK } from '../../spending/styles';
import { copy } from '../copy';
import { dayShort } from '../format';
import { useToday } from '../hooks';
import { payPath } from './DueRow';

/**
 * OPEN-QUESTIONS v0.5 Q3: an auto-debit is never marked paid by itself. On or after its due date
 * this asks "Did Internet auto-pay ₱800?"; nothing is written until Confirm (or a different amount).
 */
export function AutoPayAsk({ due }: { due: ListedDue }) {
  const env = useCommandEnv();
  const today = useToday();
  async function confirm() {
    const r = await payDue(env, due.payeeId, due.period, {
      amountMinor: due.remainingMinor,
      paidDate: due.dueDate < today ? due.dueDate : today,
      confirm: true,
    });
    if (r.ok)
      showToast({
        message: copy.paidToast(due.remainingMinor),
        action: { label: copy.undo, onPress: () => void undoPayment(env, r.paymentId) },
      });
  }
  return (
    <div
      role="group"
      aria-label={copy.autoPayAsk(due.payeeName, due.remainingMinor)}
      className="flex flex-col gap-2"
    >
      <p className="text-fg">{copy.autoPayAsk(due.payeeName, due.remainingMinor)}</p>
      <p className="text-sm text-muted">
        {dayShort(due.dueDate)}
        {due.estimated ? ` · ${copy.estimated}` : ''}
      </p>
      <div className="grid grid-cols-2 gap-2">
        <Button variant="primary" onClick={() => void confirm()}>
          {copy.confirm}
        </Button>
        <Link
          to={`${payPath(due.payeeId, due.period)}?different=1`}
          className={`${ACCENT_LINK} !bg-secondary !text-fg`}
        >
          {copy.differentAmount}
        </Link>
      </div>
    </div>
  );
}
